module.exports = __webpack_public_path__ + "img/32a754e169974459dbdded0919b88ad7.svg";